module.exports = __webpack_public_path__ + "img/document-add.d4503c6f.svg";